<!--
 * @Author: your name
 * @Date: 2021-08-10 08:10:09
 * @LastEditTime: 2022-01-26 16:15:47
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\views\layout\components\footer.vue
-->
<template>
    <div class="sidebar">
        <div class="right_aside" id="menu">
            <ul class="menu_list" v-if="queryParams.fromPage == 'home'">
                <li v-for="(item,index) in asideList" :key="item.id" :class="queryParams.fromPage == 'home' && index == 0 ? 'on' : ''"><a>{{item.name}}</a></li>
            </ul>
            <ul class="public_list">
                <li :class="queryParams.fromPage != 'home' ? 'on' : ''"><a @click="toSuggest">
                        <img class="initial" :style="{display:(queryParams.fromPage != 'home' ? 'none' : 'block')}" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/aside/fankui.png" alt="">
                        <img class="initial_choose" :style="{display:(queryParams.fromPage != 'home' ? 'block' : 'none')}" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/aside/fankuichoosed.png" alt="">
                        <span>反馈</span>
                    </a></li>
                <li><a @click="toArticleDetail(3)">
                        <img class="initial" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/aside/kefu.png" alt="">
                        <img class="initial_choose" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/aside/kefuchoosed.png" alt="">
                        <span>电话</span>
                    </a></li>
                <li class="last" style="display:none"><a>
                    <img class="initial" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/aside/back_to_top.png" alt="">
                    <img class="initial_choose" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/aside/back_to_top_choosed.png" alt="">
                    <span>顶部</span>
                </a></li>
            </ul>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import store from "@/store/index";
export default {
    inject: ["reload"], //注入强制刷新依赖
    data() {
        return {
            asideList: [
                {
                    id: "10001",
                    name: "限时特价",
                },
                {
                    id: "10002",
                    name: "热销推荐",
                },
                {
                    id: "10003",
                    name: "精选推荐",
                },
            ],
            newActivityTop: "80%",
        };
    },
    props: {
        queryParams: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    computed: {
        loginName: function () {
            return store.getters.getUserName;
        },
    },
    mounted() {
        this.hoverStyle();
        this.floorStyle();

        window.addEventListener("scroll", this.changeTop);

        // this.initCustomerService();
    },
    methods: {
        //鼠标划过样式
        hoverStyle() {
            let that = this;
            $(".right_aside ul li").mouseenter(function () {
                $(this).addClass("on").siblings("li").removeClass("on");
                $(this).parent().siblings().children("li").removeClass("on");

                // $(this).children("a").children(".showTips").css({ display: "block", color: "#333333" });
                $(this).children("a").children(".initial").css("display", "none");
                $(this).children("a").children(".initial_choose").css("display", "block");

                // $(this).siblings("li").children("a").children(".showTips").css("display", "none");
                $(this).siblings("li").children("a").children(".initial").css("display", "block");
                $(this).siblings("li").children("a").children(".initial_choose").css("display", "none");
            });
            $(".right_aside ").mouseleave(function () {
                if (that.queryParams.fromPage == "home") {
                    // $(this).children("ul").eq(1).children("li").children("a").children(".showTips").css("display", "none");
                    $(this).children("ul").eq(1).children("li").children("a").children(".initial").css("display", "block");
                    $(this).children("ul").eq(1).children("li").children("a").children(".initial_choose").css("display", "none");
                } else {
                    // $(this).children("ul").eq(0).children("li").children("a").children(".showTips").css("display", "none");
                    $(this).children("ul").eq(0).children("li").children("a").children(".initial").css("display", "block");
                    $(this).children("ul").eq(0).children("li").children("a").children(".initial_choose").css("display", "none");
                }
                $(this).children("ul").children("li").removeClass("on");

                $(this).children("ul").eq(0).children("li").eq(0).addClass("on");
                $(this).children("ul").eq(0).children("li").eq(0).children("a").children(".initial").css("display", "none");
                $(this).children("ul").eq(0).children("li").eq(0).children("a").children(".initial_choose").css("display", "block");
            });
        },

        toSuggest() {
            const token = store.getters.getToken;
            if (token) {
                this.$router.push({ path: "/personal/suggest" });
            } else {
                this.$router.push({ path: "/passport/login" });
            }
        },

        toArticleDetail(articleId){
            this.$router.push({ path: "/article/articleDetail",query: {id:articleId}});
            this.reload()
        },

        //楼梯效果
        floorStyle() {
            $(".menu_list li").eq(0).addClass("on");
            var flag = true; //控制 当点击楼层号时，禁止滚动条的代码执行   值为true时，可以执行滚动条代码
            //  根据楼层号 控制滚走的距离
            // 1、除了top的楼梯号，为每一个楼梯号添加一个click，控制楼梯滚走的距离（距离：当前楼层的offset().top ）
            $("#menu .menu_list li").click(function () {
                flag = false;
                //当前点击的楼号为蓝色
                $(this).addClass("on").siblings("li").removeClass("on");

                //获取当前楼号对应楼层的 top值
                var sTop = $(".Louti").eq($(this).index()).offset().top - 72;

                //将页面滚走的距离设置为  sTop
                $("body,html").animate({scrollTop: sTop,},1000,
                    function () {
                        flag = true;
                    }
                );
            });
            //2、点击top   回到顶部
            $("#menu .public_list li:last").click(function () {
                $("body,html").animate({scrollTop: 0,},1000);
                $("#menu .menu_list li").removeClass("on");
            });

            //3、 滚动条滚动 --  找到当前楼层的索引    控制楼层号
            $(window).scroll(function () {
                //如果flag  为true   可以执行滚动条的代码
                if (flag) {
                    //获取页面滚走的距离
                    var sTop = $(document).scrollTop();
                    //filter  返回满足条件的那个对象
                    //找到满足某个条件的楼层对象
                    var floor = $(".Louti").filter(function (index, ele) {
                        return (
                            Math.abs($(this).offset().top - sTop) <
                            $(this).height()
                        );
                    });
                    //根据楼层的索引 设置楼梯号的 样式
                    if (floor.index() < 0) {
                        $("#menu .menu_list li")
                            .eq(0)
                            .addClass("on")
                            .siblings("li")
                            .removeClass("on");
                    } else {
                        $("#menu .menu_list li")
                            .eq(floor.index())
                            .addClass("on")
                            .siblings("li")
                            .removeClass("on");
                    }
                }
            });
        },

        //更改新品首发、热销推荐侧边栏距离顶部的距离
        changeTop() {
            const that = this;
            let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 0) {
                $(".sidebar").css({ position: "fixed", top: "330px" });
            } else {
                $(".sidebar").css({ position: "absolute", top: "330px" });
            }
            
            //滚动到一定的距离才会出现返回顶部按钮
            if (scrollTop > 750) {
                $("#menu .public_list li:last").css({ display: "block"});
            } else {
                $("#menu .public_list li:last").css({ display: "none"});
            }
        },
        initCustomerService() {
            this.customerService.initCustomerService();
        },
    },
    destroyed() {
        window.removeEventListener("scroll", this.changeTop);
    },
};
</script>
<style scoped>
ul {
    margin: 0;
}
ul li {
    list-style: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
}
a {
    text-decoration: none;
    color: #666666;
}
.sidebar {
    width: 1200px;
    height: 1px;
    margin: 0 auto;
    position: absolute;
    top: 330px;
    left: calc(50% - 600px);
}
.right_aside {
    width: 55px;
    background: #ffffff;
    border-radius: 2px;
    position: fixed;
    /* top: 35vh; */
    top: 35%;
    right: 0;
    box-shadow: 0 0 10px 0px #eeeeee;
    z-index: 9999 !important;
}
.right_aside ul li {
    border-bottom: 1px solid #f3f3f3;
    position: relative;
}
.right_aside .public_list li:last-child {
    border-bottom: 0px solid #f3f3f3;
}
.right_aside ul li a {
    width: calc(100% - 28px);
    display: block;
    padding: 14px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
}
.right_aside ul li a img {
    width: 17px;
    height: 17px;
    margin-left: 5px;
}
.right_aside ul li.on a {
    background-color: #e1251b;
    color: #ffffff;
}
.showTips {
    display: none;
    padding: 10px 10px;
    background-color: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 10px;
    position: absolute;
    top: 12px;
}
.initial_choose {
    display: none;
}
.phone {
    right: -115px;
}
.triangle {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-right: 5px solid #ffffff;
    border-bottom: 5px solid transparent;
    position: absolute;
    left: -5px;
    top: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/pageComponents/rightAside.vue